/**
 * Erreurs HTTP du client API — le corps standard de l'API est
 * `{ statusCode, error, message }` (`@fastify/sensible`).
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly body: unknown = undefined,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

const STATUS_MESSAGES: Record<number, string> = {
  400: 'Requête invalide.',
  401: 'Authentification requise.',
  403: 'Vous n’avez pas les droits nécessaires.',
  404: 'Introuvable.',
  409: 'Conflit avec une donnée existante.',
  429: 'Trop de tentatives — patientez quelques minutes avant de réessayer.',
  503: 'Service momentanément indisponible.',
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError
}

/** Message affichable : celui du serveur, sinon celui du statut, sinon `fallback`. */
export function apiErrorMessage(err: unknown, fallback = 'Une erreur est survenue.'): string {
  if (isApiError(err)) {
    const serverMessage = (err.body as { message?: unknown } | undefined)?.message
    if (typeof serverMessage === 'string' && serverMessage) return serverMessage
    return STATUS_MESSAGES[err.status] ?? fallback
  }
  if (err instanceof TypeError) return 'Serveur injoignable — vérifiez votre connexion.'
  return fallback
}
